"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addUserApi = addUserApi;
exports.exportWithdrawApi = exportWithdrawApi;
exports.findBillApi = findBillApi;
exports.getOutLetListApi = getOutLetListApi;
exports.getUserRewardStatsApi = getUserRewardStatsApi;
exports.importUserApi = importUserApi;
exports.outLetApplyApi = outLetApplyApi;
exports.specUseApi = specUseApi;
exports.specUseCodeApi = specUseCodeApi;
exports.visitRecordListApi = visitRecordListApi;
var _request = _interopRequireDefault(require("@/utils/request"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/*
 * 1开卡数据查询列表
 * 需配置权限 admin:outlet:list
 * @param params
 *  carNo:string卡号
 *   endTime:string开卡时间-结束时间
 *   limit:number 每页数量
 *   page:number 页码
 *   startTime:string开卡时间-开始时间
 *   status:number 审核状态 0:待审核 1:审核通过 2:审核不通过
 *   tariffStandardId:number 资费标准ID
 *   uid:number 用户id
 *   useName:string 开卡人
 *   workerName:string 工作人员
 * @returns  "data": {
 *       "address": "", 归属地：使用英文逗号分隔 省市区
 *       "carNo": string 卡号
 *       "cause": string 拒绝原因
 *       "createTime": string 创建时间
 *       "id": number id
 *       "status": number 审核状态 0:待审核 1:审核通过 2:审核不通过
 *       "tariffStandardId": number 资费标准ID
 *       "tariffStandardName": string 资费标准名称
 *       "time": string 开卡时间,代表开卡日期和开卡时间
 *       "uid": number 用户id
 *       "updateTime": string 更新时间
 *       "useName": string 开卡人
 *       "workerName": string 工作人员
 *	},
 */
function getOutLetListApi(params) {
  return (0, _request.default)({
    url: '/admin/visit/outLetList',
    method: 'get',
    params: params
  });
}

/* 2开卡数据审核 
需要配置权限 admin:outlet:apply
 * @param params 	
    "cause": "", 拒绝原因
	"id": 0,
	"status": number 状态 1审核通过 2拒绝
 * @returns
 */
function outLetApplyApi(data) {
  return (0, _request.default)({
    url: '/admin/visit/outLet/apply',
    method: 'put',
    data: data
  });
}

/* 
3专用券使用 
需要配置权限 admin:voucher:bill:specUse
 * @param params 
    "code": "", 核验码
	"specNumber": number 核验数量
	"uid": number 用户id
 * @returns
*/
function specUseApi(data) {
  return (0, _request.default)({
    url: '/admin/visit/specUse',
    method: 'post',
    data: data
  });
}

/* 4预约数据查询 /admin/visit/visitRecordList
需要配置权限 admin:voucher:bill:list
 * @param params 
       endTime: string 预约时间搜索-结束时间
       limit: number 每页数量
       nickName: string 姓名
       page: number 页码
       phone: string 手机号
       place: string 预约地点
       startTime: string 预约时间搜索-开始时间
       uid: number 用户id
*/
function visitRecordListApi(params) {
  return (0, _request.default)({
    url: '/admin/visit/visitRecordList',
    method: 'get',
    params: params
  });
}

/* 5、通用券、专用券、推广奖励使用记录 /admin/visit/findBill
 @param params category:number 1通用券 2专用券 3推广奖励
 limit: number 每页数量
 page: number 页码
 pm: number 0支出 1收入
 type: number 明细类型：1=发放, 2=提现, 3=结转 (从未激活转到激活)
 startTime:string
 endTime:string
  phone:string
  uid:number
 @returns "data": {
		"endRow": 0,
		"firstPage": 0,
		"hasNextPage": true,
		"hasPreviousPage": true,
		"isFirstPage": true,
		"isLastPage": true,
		"lastPage": 0,
		"list": [
			{
				"account": "",
				"category": 0,
				"createTime": "",
				"id": 0,
				"linkId": 0,
				"number": 0,
				"pm": 0,
				"type": 0,
				"uid": 0
			}
		],
		"navigateFirstPage": 0,
		"navigateLastPage": 0,
		"navigatePages": 0,
		"navigatepageNums": [],
		"nextPage": 0,
		"pageNum": 0,
		"pageSize": 0,
		"pages": 0,
		"prePage": 0,
		"size": 0,
		"startRow": 0,
		"total": 0
	},
*/
function findBillApi(params) {
  return (0, _request.default)({
    url: '/admin/visit/findBill',
    method: 'get',
    params: params
  });
}

/* 6、提现导出 /admin/visit/exportWithdraw
需要配置权限 admin:finance:apply:export
 @param params 
    "dateLimit": string, today,yesterday,lately7,lately30,month,year,/yyyy-MM-dd hh:mm:ss,yyyy-MM-dd hh:mm:ss/
	" extractType": string, 提现方式 genVoucher（通用券）,promoIncentive（推广）
	" isExport": number, 是否导出 0 否 1 是
 * @returns 
*/
function exportWithdrawApi(params) {
  return (0, _request.default)({
    url: '/admin/finance/apply/export',
    method: 'get',
    params: params
  });
}

/* 7、导入用户 /admin/user/import-poi 
 file: file 文件 请求类型formData
 
 @returns 
*/
function importUserApi(file) {
  return (0, _request.default)({
    url: '/admin/user/import-poi',
    method: 'post',
    data: file
  });
}

/* 8、专用券使用-获取验证码
需要配置权限 admin:voucher:bill:specUse
@param params
  phone: string 手机号
*/
function specUseCodeApi(params) {
  return (0, _request.default)({
    url: '/admin/sms/sendCode',
    method: 'get',
    params: params
  });
}

// 
/*  权益发放查询 admin:user:reward
 @param params 
{
  endTime string 导入结束时间
  phone string 手机号
  startTime string 导入开始时间
  uid number 用户id
}
  @returns "data":{
	 [
		{
			"createTime": "",
			"phone": "",
			"spreadCount": 0,
			"totalGen": 0,
			"totalSpec": 0,
			"uid": 0
		}
	],
}
*/
function getUserRewardStatsApi(params) {
  return (0, _request.default)({
    url: '/admin/user/getUserRewardStats',
    method: 'get',
    params: params
  });
}

//
/* 单个添加权益 admin:user:add 
 @param data 
{
	"phone": ""
}
  */

function addUserApi(data) {
  return (0, _request.default)({
    url: '/admin/user/add-user',
    method: 'post',
    data: data
  });
}